import { gql } from "@grandvisionhq/graphql";
import { mediaFragment, assetFragment } from "./small-fragments.js";
import { productPriceItemFragment } from "../../../prices/operations/queries/fragments/prices/productPriceItem.js";
const variantFragment = gql`
  fragment variantFragment on Variant {
    assets {
      ...assetFragment
    }
    description
    displayName
    erpId
    header
    isAllowBackOrder
    isAvailableForInStoreSubscription
    isAvailableForSubscription
    isExcludedFromCheckout
    isPublished
    metaTitle
    metaDescription
    promotionIdentifier
    opcoBackendId
    sku
    usps
    media {
      ...mediaFragment
    }
    priceList {
      ...productPriceItemFragment
    }
    bestPrice
    inventory {
      items {
        channel {
          key
          id
        }
        quantity
      }
      totalQuantity
    }
    tags {
      key
      value
    }
  }
  ${mediaFragment}
  ${productPriceItemFragment}
  ${assetFragment}
`;
export {
  variantFragment
};
//# sourceMappingURL=variant.js.map
